import { TmEntityNotFoundError } from '@/core/error/tmEntityNotFoundError'

export class TmFilteredViewFoundError extends TmEntityNotFoundError<unknown> {}
